import { Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function LockedCompany({ ticker }) {
  const { login } = useAuth();
  return (
    <div data-testid="company-locked" className="py-28 text-center">
      <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-[#FCEBEB]">
        <Lock className="h-6 w-6 text-[#E24B4A]" />
      </div>
      <h1 className="mt-6 font-heading text-3xl font-bold tracking-tight text-[#1a1a18]">
        Sign in to view {ticker.toUpperCase()}
      </h1>
      <p className="mx-auto mt-3 max-w-md text-neutral-600">
        Create a free account — one click with Google — for full access to the S&amp;P 500:
        all tracked disclosures, charts and SEC sources.
      </p>
      <button
        data-testid="company-locked-signup-btn"
        onClick={() => login("company_locked_page")}
        className="mt-7 rounded-full bg-[#E24B4A] px-6 py-3 text-sm font-medium text-white transition-transform active:scale-95 hover:opacity-90"
      >
        Sign up free with Google
      </button>
      <div className="mt-4 text-sm text-neutral-400">Already have an account? It signs you in the same way.</div>
    </div>
  );
}
